import { SegmentStatResponseDTO } from '@core/api/dtos/response/radio/segmentStat'
import { SegmentStat } from '@core/api/entities/radio/segmentStat'

export class SegmentStatMapper {
	static toEntity(data: SegmentStatResponseDTO): SegmentStat {
		return new SegmentStat({
			nodes: data.nodes,
			nodeType: data.node_type,
			categories: data.categories,
		})
	}

	static toEntities(data: SegmentStatResponseDTO[]): SegmentStat[] {
		return data.map((stat) => this.toEntity(stat))
	}
}
